import { Component, Input } from '@angular/core';
import { AuthService } from '../../../services/auth.service';

@Component({
    selector: 'prof-topnav-onetrust',
    templateUrl: './topnav-onetrust.component.html',
    styleUrl: './topnav-onetrust.component.scss',
    standalone: false
})
export class TopnavOnetrustComponent {
  @Input() title: string;
  constructor(public auth: AuthService) {}

  ngOnInit(): void {
  }
}
